<template>
      <form v-if="item" v-on:submit.prevent="submitForm">
        <div class="row">
          <div class="col-md-12" v-if="item.id">
            
            <div class="form-group">
              <label class="mt20">
                {{'Status'|translate}}
              </label>
             {{showStatus(item.status)}}
            </div>
          </div>
          <div class="col-md-12">
            
            <div class="form-group">
              <label >
                {{'Location'|translate}}
                <span class="required">(*)</span>
              </label>
              <textarea
                v-model="item.location"
                required
                :disabled="item.id && item.status != 0"
                ref="location"
                :placeholder="'Location'|translate"
                class="form-control"
              ></textarea>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label>
              {{'Buyer Behaviour'|translate}}
              <span class="required">(*)</span>
            </label>
            <select class="form-control" v-if="!item.id" v-model="item.buyer_index" required>
              <option disabled value>{{'Please select one'|translate}}</option>
              <option v-for="(buyer,index) in from_buyers" :key="index" v-bind:value="index">
                {{ buyer.name }}
                <span>({{buyer.type|translate}})</span>
              </option>
            </select>
            <p v-if="item.id">
              {{item.buyer_name}}
              <span>({{item.buyer_type|translate}})</span>
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label>
              {{'Farmers/Group'|translate}}
              <span class="required">(*)</span>
            </label>
            <autocomplete
              ref="autocomplete"
              v-if="!selected_seller"
              :placeholder="'Search' | translate"
              :source="distributionGroupsEndpoint"
              input-class="form-control"
              results-property="data"
              :results-display="formattedDisplay"
              :request-headers="authHeaders"
              @selected="selectedMember"
            ></autocomplete>
            <p v-if="selected_seller">
              {{selected_seller.name}}
              <span>({{selected_seller.type|translate}})</span>
              <i
                v-if="!item.id"
                class="fas fa-times pointer pull-right"
                v-on:click="selected_seller = null"
              ></i>
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="mt20">{{'Note'|translate}}</label>
              <textarea
                v-model="item.note"
                ref="address"
                :disabled="item.id && item.status != 0"
                :placeholder="'Note'|translate"
                class="form-control"
              ></textarea>
            </div>
          </div>
        </div>
        <p class="mt20">
          <button
            class="btn btn-info"
            type="submit"
            v-if="item.status == 0"
            :disabled="updating"
          >
            <i v-if="updating" class="fas fa-spinner fa-spin"></i>
            {{getOKText}}
          </button>
          
          <a
            class="btn btn-danger"
            v-if="item.id && item.status == 0"
            v-on:click="removeItem(item)"
            :disabled="removing"
          ><i v-if="removing" class="fas fa-spinner fa-spin"></i> {{'Delete'|translate}}</a>
          <a
            v-if="item.id && item.status == 0"
            class="btn btn-primary"
            v-on:click="updateStatus(item, 'send')"
            :disabled="updating"
          > <i v-if="updating" class="fas fa-spinner fa-spin"></i> {{'Send'|translate}}</a>

          <a
            v-if="item.id && item.status == 1 && item.seller_user_id === user['id'] "
            class="btn btn-primary"
            v-on:click="updateStatus(item,'confirm')"
          :disabled="updating"
          > <i v-if="updating" class="fas fa-spinner fa-spin"></i> {{'Confirm'|translate}}</a>
          <a
            v-if="item.id && item.status == 2 && item.seller_user_id === user['id'] "
            class="btn btn-primary"
            v-on:click="updateStatus(item,'delivery')"
          :disabled="updating">
          <i v-if="updating" class="fas fa-spinner fa-spin"></i> {{'Set as delivery'|translate}}</a>
          <a
            v-if="item.id && item.status == 3 && item.buyer_user_id === user['id'] "
            class="btn btn-primary"
            v-on:click="updateStatus(item,'done')"
          :disabled="updating"
          > <i v-if="updating" class="fas fa-spinner fa-spin"></i> 
          {{'Set as done'|translate}}</a>


        </p>
      </form>
    
</template>
<script>

import Utils from "@/helpers/utils";
import datePicker from "vue-bootstrap-datetimepicker";
import Loading from "@/components/elements/Loading";
import Config from "@/helpers/config";
import Autocomplete from "vuejs-auto-complete";
//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "FormSubUser",
  components: {
    
    Loading,
    Autocomplete
  },
  props: [ "from_buyers"],
  computed: {
    authHeaders() {
      return Utils.getHeader(this);
    },
    getTitleText() {
      if (this.item.id) {
        return this.item.status == 0
          ? this.$t("Update purchase")
          : this.$t("View purchase");
      } else {
        return this.$t("Add purchase");
      }
    },
    getOKText() {
      if (this.item.id) {
        return this.$t("Update");
      } else {
        return this.$t("Add");
      }
    }
  },
  data() {
    let dateFormat = "DD/MM/YYYY";
    return {
      working: false,
      updating: false,
      removing:false,
      user: null,
      src_image: "/static/images/no-photo.jpg",
      selected_seller: null,
      dateFormat: dateFormat,
      item: null
    };
  },
  created() {
    // clone from original params
  },

  methods: {
    defaultValue() {
      return {
        
        note: "",
        location: "",
        status: 0,
        buyer_index: ""
      };
    },

    submitForm() {
      if (!this.selected_seller) {
        return this.$alertify.alertWithTitle(
          this.$t("Confirm"),
          this.$t("Please select seller(farmer or group)")
        );
      }

      if (!this.item.id){
        this.item.buyer_id = this.from_buyers[this.item.buyer_index].id;
        this.item.buyer_type = this.from_buyers[this.item.buyer_index].type;
        this.item.seller_id = this.selected_seller.id;
        this.item.seller_type = this.selected_seller.type;
      }
      
      let data = JSON.parse(JSON.stringify(this.item));
      delete data.buyer_index;

      let request;
      if (this.item.id) {
        // PUT request does not support validation
        request = Utils.request(this, true, "purchase").put(
          `/manageOrder/`,
          data
        );
      } else {
        request = Utils.request(this, true, "purchase").post(
          `/manageOrder/`,
          data
        );
      }
      this.updating = true;
      request
        .then(response => {
          let data = response.data;
          this.updating = false;
          if (data.status === "ok") {
            Utils.showSuccess(this, this.$t("Order is updated"));
            this.$emit("updatePurchase", data.data);
          } else {
            Utils.showError(this, this.$t(data.data));
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    showStatus(status) {
     return Utils.orderStatus(status)
    },
    distributionGroupsEndpoint(input) {
      return Utils.getRequestUrl("group") + "/search_buyer?q=" + input;
    },
    formattedDisplay(result) {
      let image_path = result.feature_image_path
        ? result.feature_image_path
        : this.src_image;

      let type = result.type == "farmer" ? "Farmer" : "Group";
      return (
        `<img src='${image_path}' width='50' height='50'/> ` +
        result.name +
        `( ${this.$t(result.type)} )`
      );
    },
    selectedMember(member) {
      this.$refs.autocomplete.clear();
      this.selected_seller = member.selectedObject;
    },
    updateData(pass_data) {
      this.user = Utils.getUser(this);
        this.selected_seller = null;
        if (pass_data) {
          this.item = JSON.parse(JSON.stringify(pass_data));

          // selected_seller
          this.selected_seller = {
            id: this.item.seller_id,
            name: this.item.seller_name,
            type: this.item.seller_type
          };

          if (this.from_buyers){
            for (var i = 0; i < this.from_buyers.length; i++) {
              if (
                this.from_buyers[i].id == this.item.buyer_id &&
                this.from_buyers[i].type == this.item.buyer_type
              ) {
                this.item.buyer_index = i;
                break;
              }
            }
          }

        } else {
          this.item = this.defaultValue();
        }
    },
    updateStatus(purchase, path) {
      var message = "";
      
      switch( path ){
        case 'send': 
          message = this.$t("Are you sure to send this purchase and send to seller ?");
          break;
        case 'confirm': 
          message = this.$t("Are you sure to confirm this purchase to buyer ?");
          break;
        case 'delivery': 
          message = this.$t("Are you sure to set this purchase is delivery to buyer ?");
          break;
        case 'done': 
          message =  this.$t("Are you sure to set this purchase is done ?");
          break;
      }
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        message,
        () => {
          this.updating= true;
          Utils.request(this, true, "purchase")
            .put(`/${path}/${purchase.id}`)
            .then(response => {
              this.updating = false;
              let data = response.data;
              if (data.status === "ok") {
                Utils.showSuccess(this, this.$t("Order is updated"));
                this.updateData(data.data);
                this.$emit("updatePurchase", data.data);
              } else {
                Utils.showError(this, data.data);
              }
            });
        }
      );
    },
    removeItem(item) {
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t("Are you sure to remove this item ?"),
        () => {
          this.removing = true;
          Utils.request(this, true, "purchase")
            .delete(`/manageOrder/${item.id}`)
            .then(response => {
              this.removing = false;
              let data = response.data;
              if (data.status === "ok") {
               this.$router.push({ name: "ListPurchase" });
              }
            });
        }
      );
    },
  }

};
</script>


// WEBPACK FOOTER //
// src/components/Purchase/FormPurchase.vue